import { getYear } from 'date-fns';
import { useMemo } from 'react';
import { ITimeZone } from 'src/types/OrderHistory';
import { getFormattedTimezoneFromObject } from 'src/utilities/time-utils';

// e.g. Tue, Aug 9 at 7:59am EDT
export const DATE_FORMAT_CURRENT_YEAR = "EEE, MMM d 'at' h:mmaaa";
// e.g. Dec 10 1999 at 7:59am EDT
export const DATE_FORMAT_PAST_YEARS = "MMM d yyyy 'at' h:mmaaa";

export const useFormattedDate = (
  utcDate: string,
  timeZone: ITimeZone
): { formattedDate: string } => {
  const formattedDate = useMemo(() => {
    const currentYear = getYear(new Date());
    const currentOrderYear = getYear(new Date(utcDate));
    const getDateFormatPerYear = () =>
      currentYear === currentOrderYear
        ? DATE_FORMAT_CURRENT_YEAR
        : DATE_FORMAT_PAST_YEARS;

    return getFormattedTimezoneFromObject(
      utcDate,
      timeZone,
      getDateFormatPerYear()
    );
  }, [utcDate, timeZone]);

  return { formattedDate };
};
